function Help() {

return (
    <>
    Official documentation at <a href="https://help.bdq.cloud/" target="_blank" rel="noopener noreferrer">https://help.bdq.cloud/</a>
    </>
)
}

export default Help;